import { render } from "./loginPage.vue?vue&type=template&id=21f872af&scoped=true"
import script from "./loginPage.vue?vue&type=script&lang=js"
export * from "./loginPage.vue?vue&type=script&lang=js"

import "./loginPage.vue?vue&type=style&index=0&id=21f872af&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f872af"]])

export default __exports__